import { render, staticRenderFns } from "./FormModule.vue?vue&type=template&id=1413c605&scoped=true"
import script from "./FormModule.vue?vue&type=script&lang=js"
export * from "./FormModule.vue?vue&type=script&lang=js"
import style0 from "./FormModule.vue?vue&type=style&index=0&id=1413c605&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1413c605",
  null
  
)

export default component.exports